import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from 'Components';
import styles from './PrefilledForm.module.scss';

interface ThumbnailUploaderProps {
  isSuperAdmin: boolean;
  hasError?: boolean;
  onTriggerFileInput: () => void;
}

export const ThumbnailUploader: React.FC<ThumbnailUploaderProps> = ({
  isSuperAdmin,
  hasError = false,
  onTriggerFileInput
}) => {
  const { t } = useTranslation();

  return (
    <div
      onClick={isSuperAdmin ? onTriggerFileInput : undefined}
      className={`${styles.emptyUploadCard} ${!isSuperAdmin ? styles.disabled : ''} ${
        hasError ? styles.hasError : ''
      }`}
    >
      <div className={styles.uploadContentWrapper}>
        <div className={styles.uploadIconBadge}>
          <div className={styles.uploadIconBox}>
            <Icon type="image" />
          </div>
        </div>
        <div className={styles.uploadTextGroup}>
          <div className={styles.uploadTitle}>
            {t('phishingTemplateManager.prefilledForm.uploadFileTitle')}
          </div>
          <div className={styles.uploadSubtitle}>
            {t('phishingTemplateManager.prefilledForm.uploadFileSubtitle')}
          </div>
        </div>
        <div className={styles.chooseFileButton}>
          <Icon type="upload" />
          <span className={styles.chooseFileBtnText}>
            {t('phishingTemplateManager.prefilledForm.chooseFileBtn')}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ThumbnailUploader;